import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { useAuth } from '@/contexts/auth';

/**
 * Hook to get the count of unfinished tasks assigned to the current user
 * Only counts tasks where user is assignee (not owned tasks unless also assigned)
 * Matches the same filtering logic as TaskManager page
 */
export const useAssignedTasksCount = () => {
  const { user } = useAuth();

  return useQuery({
    queryKey: ['assigned-tasks-count', user?.id],
    queryFn: async () => {
      if (!user?.id) return 0;

      // Count tasks where user is assignee using INNER JOIN (same logic as fetchAssignedTasks)
      const { count, error } = await supabase
        .from('planner_tasks')
        .select('*, planner_tasks_assignees!inner(assignee_id)', { count: 'exact', head: true })
        .eq('planner_tasks_assignees.assignee_id', user.id)
        .eq('is_completed', false);

      if (error) {
        console.error('Error fetching assigned tasks count:', error);
        return 0;
      }

      return count || 0;
    },
    enabled: !!user?.id,
    staleTime: 30000, // Cache for 30 seconds
    refetchOnWindowFocus: true,
  });
}; 